// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VJeHfP_qeByfLq74VxXC{background:rgba(0,0,0,.3);border-radius:4px;font-size:0;font-family:Roboto,sans-serif}.tqwngmx5qCOwINhI_7ll,.PgJsC_Fxnm98_v3d5NKr{display:flex;flex-direction:row;align-items:center;white-space:nowrap;overflow:hidden;color:#fff;flex:1}.cIA3B_9jpRXnVAEKory9{width:20px;height:20px}.PgJsC_Fxnm98_v3d5NKr{flex-direction:row-reverse}.H9QFPjtlTTK6SbCdSuT0{padding:4px;font-size:11px;line-height:12px;font-weight:500;text-overflow:ellipsis;overflow:hidden}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandBar": "VJeHfP_qeByfLq74VxXC",
	"brandBarContainer": "tqwngmx5qCOwINhI_7ll",
	"brandBarContainerReverse": "PgJsC_Fxnm98_v3d5NKr",
	"brandbarLogo": "cIA3B_9jpRXnVAEKory9",
	"brandbarName": "H9QFPjtlTTK6SbCdSuT0"
};
export default ___CSS_LOADER_EXPORT___;
